import { useContext as useReactContext } from 'react';

import { Context } from './context';

export const useAuthContext = () => {
  const context = useReactContext(Context);

  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }

  return context;
};
